import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreUiDirectivesModule } from "../directives/core-ui-directives.module";
import { CoreUIIconsModule } from "../icons/core-ui-icons.module";
import { CoreUiLoaderModule } from "../loader/core-ui-inputs.module";
import { ButtonBaseComponent } from "./atoms/button/button-base.component";
@NgModule({
    declarations: [
        ButtonBaseComponent
    ],
    imports: [
        CommonModule,
        CoreUiDirectivesModule,
        CoreUIIconsModule,
        CoreUiLoaderModule,
    ],
    exports: [
        ButtonBaseComponent
    ]
})
export class CoreUiButtonsModule { }
